import { notificationSchema } from "@/schemas/notifications";
import { useRestPaginatedQuery } from "../useRestPaginatedQuery";
import { querykeys } from "../constants";

// kill-hasura: notificaciones por REST (GET /api/v1/notifications). Envelope
// BFF: { data: Notif[], total, page, limit }. Mismo shape que el
// getNotifications de Hasura (tabla messaging_user_notifications) con la
// relacion `notification` anidada, asi que los access-paths dentro de cada
// notificacion no cambian para los consumidores. El BFF deriva business + user
// del JWT.
//
// Firma compatible con useGetNotifications:
// (operators, enabled, uniqueQuery, hasPagination).
function useGetNotificationsRest(
  operators: any = [],
  enabled: any = true,
  uniqueQuery: any = [],
  hasPagination: any = true
) {
  const { query, items, ...pagination } = useRestPaginatedQuery({
    queryKey: querykeys.notifications,
    url: "/api/v1/notifications",
    operators,
    enabled,
    uniqueQuery,
    hasPagination,
    itemSchema: notificationSchema,
  });

  return {
    notifications: query,
    items,
    ...pagination,
  };
}

export default useGetNotificationsRest;
